'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var log = (0, _utils.getLog)('[WinresFault]');

var WinresFaultController = function () {
    function WinresFaultController($scope, $filter) {
        _classCallCheck(this, WinresFaultController);

        this.$scope = $scope;
        this.i18next = $filter('i18next');
    }

    _createClass(WinresFaultController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.$scope.ready = false;
            this.$scope.isWinresFault = false;
            this.$scope.$watch(function () {
                return _this.error;
            }, function (error) {
                return _this.process(error);
            });
        }
    }, {
        key: 'process',
        value: function process(error) {
            this.$scope.ready = false;
            if (error && error.data && error.data.FaultType) {
                this.processWinresFault(error, error.status, error.data);
            } else {
                // Some other error. Don't know what to do.
                this.processOther(error);
            }
        }
    }, {
        key: 'processWinresFault',
        value: function processWinresFault(error, status, data) {
            this.$scope.isWinresFault = true;
            this.$scope.status = status;
            this.$scope.data = data;

            var key = 'winres_fault.fault_type.' + data.FaultType;
            var message = this.i18next(key);

            var translationMissing = message == key;
            if (translationMissing) {
                // Find a generic error message that can be shown to the user.
                message = this.i18next('winres_fault.other', { error: data.FaultType });
            }

            this.$scope.genericMessage = message;

            this.$scope.ready = true;
        }
    }, {
        key: 'processOther',
        value: function processOther() {
            this.$scope.isWinresFault = false;
            this.$scope.ready = true;
        }
    }]);

    return WinresFaultController;
}();

WinresFaultController.$inject = ['$scope', '$filter'];

_module3.default.component('winresFault', {
    template: require('./winresFault.html'),
    controller: WinresFaultController,
    bindings: {
        error: '<'
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresFault/winresFault.js
// module id = 307
// module chunks = 2